export default "__VITE_ASSET__BoVRRUR3__"